import mitt, {Emitter, Handler} from 'mitt'
import {Events} from "vue";

let emit: Emitter<any> | null = null

enum EVENTS {
    SET_EMAIL = "set_email"
}

function getInstance(): Emitter<any> {
    if (!emit)
        emit = mitt();

    return emit;
}

function sendEvent(event: EVENTS, data?: any) {
    getInstance().emit(event, data)
}

function subscribeEvent(event: EVENTS, handler: Handler<Events[]>) {
    getInstance().on(event, handler)
}

export {
    EVENTS,
    sendEvent,
    subscribeEvent
}